/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon20Light = forwardRef('CheckAIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17.809 4.803a.5.5 0 0 1 0 .707l-8.54 8.54c-.97.97-2.544.97-3.514 0l-3.171-3.17a.5.5 0 0 1 .707-.708l3.171 3.171c.58.58 1.52.58 2.1 0l8.54-8.54a.5.5 0 0 1 .707 0Z" })));
});
